(function () {
    const selectors$X = {
      tooltip: "[data-tooltip]",
      tooltipContainer: "[data-tooltip-container]",
      tooltipArrow: "[data-tooltip-arrow]",
      aos: "[data-aos]",
    };

    const classes$L = {
      root: "tooltip-default",
      isAnimating: "is-animating",
      visible: "is-visible",
      hiding: "is-hiding",
    };

    const attributes$D = {
      tooltip: "data-tooltip",
      tooltipContainer: "data-tooltip-container",
      tooltipStopMouseEnter: "data-tooltip-stop-mouseenter",
    };

    const sections$z = {};
    class Tooltip {

      constructor(el) {
        this.tooltip = el;
        if (!this.tooltip.hasAttribute(attributes$D.tooltip)) {
          return;
        }

        this.rootClass = classes$L.root;
        this.isAnimatingClass = classes$L.isAnimating;
        this.label = this.tooltip.getAttribute(attributes$D.tooltip);
        this.transitionSpeed = 200;
        this.hideTransitionTimeout = 0;
        this.animatedContainer = this.tooltip.closest(selectors$X.aos);
        this.addPinEvent = () => this.addPin();
        this.addPinMouseEvent = () => this.addPin(true);
        this.removePinEvent = (event) => throttle(this.removePin(event), 50);
        this.removePinMouseEvent = (event) => this.removePin(event, true, true);
        this.init();
      }

      init() {
     
        if (!document.querySelector(selectors$X.tooltipContainer)) {

          const tooltipTemplate = `<div class="${this.rootClass}__inner"><div class="${this.rootClass}__arrow" data-tooltip-arrow></div><div class="${this.rootClass}__text"></div></div>`;
          const tooltipElement = document.createElement("div");
          tooltipElement.className = `${this.rootClass}`;
          tooltipElement.setAttribute(attributes$D.tooltipContainer, "");
          tooltipElement.innerHTML = tooltipTemplate;
          console.log('init tooltip class',tooltipElement);
          document.body.appendChild(tooltipElement);
        }

        this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent);
        this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent);
        this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent);
        document.addEventListener("theme:tooltip:close", this.removePinEvent);

        const tooltipTarget = document.querySelector(selectors$X.tooltipContainer);

      
 
        
      }

      addPin(stopMouseEnter = false) {
        console.log('addPin');
        const tooltipTarget = document.querySelector(selectors$X.tooltipContainer);
        const tooltipTargetArrow = tooltipTarget.querySelector(selectors$X.tooltipArrow);

  

        if (
          tooltipTarget &&
          ((stopMouseEnter && !this.tooltip.hasAttribute(attributes$D.tooltipStopMouseEnter)) ||
            !stopMouseEnter)
        ) {
    
          const tooltipTargetInner = tooltipTarget.querySelector(`.${this.rootClass}__inner`);
          const tooltipTargetText = tooltipTarget.querySelector(`.${this.rootClass}__text`);
          tooltipTargetText.textContent = this.label;


          console.log('tooltipTargetText', this.tooltip.getBoundingClientRect() );


          const tooltipTargetWidth = tooltipTargetInner.offsetWidth;
          const tooltipRect = this.tooltip.getBoundingClientRect();
          const tooltipTop = tooltipRect.top;
          const tooltipWidth = tooltipRect.width;
          const tooltipHeight = tooltipRect.height;
          const tooltipTargetPositionTop = tooltipTop + tooltipHeight + window.scrollY;
          let tooltipTargetPositionLeft = tooltipRect.left - tooltipTargetWidth / 2 + tooltipWidth / 2;
          let tooltipArrowPositionLeft = "50%";
          const tooltipLeftWithWidth = tooltipTargetPositionLeft + tooltipTargetWidth;
          const tooltipTargetWindowDifference = tooltipLeftWithWidth - window.innerWidth;

          if (tooltipTargetWindowDifference > 0) {
            tooltipTargetPositionLeft -= tooltipTargetWindowDifference;
          }

          if (tooltipTargetPositionLeft < 0) {
            tooltipArrowPositionLeft = `calc(50% + ${tooltipTargetPositionLeft}px)`;
            tooltipTargetPositionLeft = 0;
          }

          
          console.log('tooltipTargetText', tooltipTargetPositionLeft,tooltipTargetPositionTop );

          tooltipTargetArrow.style.left = tooltipArrowPositionLeft;
          tooltipTarget.style.transform = `translate(${tooltipTargetPositionLeft}px, ${tooltipTargetPositionTop}px)`;
          tooltipTarget.classList.remove(classes$L.hiding);
          tooltipTarget.classList.add(classes$L.visible);

          document.addEventListener("theme:scroll", this.removePinEvent);
        }
      }

      removePin(event, stopMouseEnter = false, hideTransition = false) {
        console.log('removePin');
        const tooltipTarget = document.querySelector(selectors$X.tooltipContainer);
        const tooltipVisible = tooltipTarget.classList.contains(classes$L.visible);

        if (
          tooltipTarget &&
          ((stopMouseEnter && !this.tooltip.hasAttribute(attributes$D.tooltipStopMouseEnter)) ||
            !stopMouseEnter)
        ) {
          if (tooltipVisible && (hideTransition || event.detail.hideTransition)) {
            tooltipTarget.classList.add(classes$L.hiding);

            if (this.hideTransitionTimeout) {
              clearTimeout(this.hideTransitionTimeout);
            }

            this.hideTransitionTimeout = setTimeout(() => {
              tooltipTarget.classList.remove(classes$L.hiding);
            }, this.transitionSpeed);
          }

          tooltipTarget.classList.remove(classes$L.visible);

          // tooltipTarget.style.transform = `translate(100%, 0)`;


          document.removeEventListener("theme:scroll", this.removePinEvent);
        }
      }

      unload() {
        this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent);
        this.tooltip.removeEventListener("mouseleave", this.removePinMouseEvent);
        this.tooltip.removeEventListener("theme:tooltip:init", this.addPinEvent);
        document.removeEventListener("theme:tooltip:close", this.removePinEvent);
        document.removeEventListener("theme:scroll", this.removePinEvent);
      }
    }

    const tooltip = {
      onLoad() {
        sections$z[this.id] = [];
        const tooltips = this.container.querySelectorAll(selectors$X.tooltip);
        tooltips.forEach((tooltip) => {
          sections$z[this.id].push(new Tooltip(tooltip));
        });
      },
      onUnload() {
        sections$z[this.id].forEach((tooltip) => {
          if (typeof tooltip.unload === "function") {
            tooltip.unload();
          }
        });
      },
    };

  const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  const selectors$A = {
    tooltip: "[data-tooltip]"
  };

  const initTooltips = () => {
    console.log('init tooltips');
    this.tooltips = document.querySelectorAll(selectors$A.tooltip);

    if (window.matchMedia('(max-width: 749px)').matches) {
      this.tooltips = document.querySelectorAll(selectors$A.tooltip);
    }
    

    this.tooltips?.forEach((tooltip) => {
      new Tooltip(tooltip);
    });
  }

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
    initTooltips();
  });

  initProductAccordion();
  initZoomImage();
  initTooltips();

  

})();
